import axios from 'axios'
import {AXIOS_DEFAULT_CONFIG} from '@/config/index'
import {
  reqSucCallback,
  reqFailCallback
  // resSucCallback,
  // resFailCallback
} from '@/config/interceptors/axios'
import router from '@/router'
let axiosInstance = axios.create(AXIOS_DEFAULT_CONFIG)
axiosInstance.interceptors.request.use(reqSucCallback, reqFailCallback)
axiosInstance.interceptors.response.use((response)=>{
  if (response.data.code === 401) {
    router.push("/401");
    return Promise.reject(response.data.msg);
  }
  return response;
}, (error)=>{return Promise.reject(error);})
export default axiosInstance
